import { env } from "@/web/lib/env";
import { NominateButton } from "@/web/routes/-nomination/NominateButton";
import { AwardIcon } from "lucide-react";

export function NoMatchesCta() {
  return (
    <div
      className="relative flex h-[600px] w-full flex-col items-center justify-center rounded-none"
      style={{
        backgroundImage: `url('${env.VITE_WITHCO_IMAGE_CDN_BASE}/noCampaignMatches.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex w-full max-w-[855px] flex-col items-center gap-[22px] px-4 text-center">
        <h2 className="withus-strong text-[50px] text-withus-yellow">
          We couldn&apos;t find anything that matched your criteria
        </h2>
        <p className="text-[18px] text-white/80">
          Have a favorite business you think should own their real estate?
        </p>
        <NominateButton label="Nominate a business" icon={AwardIcon} color="red" />
      </div>
    </div>
  );
}
